import { render, staticRenderFns } from "./TVPPrePaymentItem.vue?vue&type=template&id=4b64fe4e&scoped=true&"
import script from "./TVPPrePaymentItem.vue?vue&type=script&lang=js&"
export * from "./TVPPrePaymentItem.vue?vue&type=script&lang=js&"
import style0 from "./TVPPrePaymentItem.vue?vue&type=style&index=0&id=4b64fe4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b64fe4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
